module.exports = __webpack_public_path__ + "static/media/flag-ico-us.1cf9a85f.png";